export const isValidNumber = (value: string) => {
  const reg = /^\d+(\.\d+)?$/; // Allow only numbers and dot
  return reg.test(value) || value === "";
};

export const isValidBudget = (value: string) => {
  const reg = /^\d+$/; // Allow only 10 digits without dot
  return (reg.test(value) && parseInt(value, 10) >= 1 && value.length <= 10) || value === "";
};
